import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {Fragment} from "react";
import Box from '@mui/material/Box';
import {getJSXCircle} from "../helpers";

const GetIdentifier = (props) => {
    return (
        <Fragment>
            <Grid item lg={12}>
            <Typography variant={"h6"} > IDENTIFIER </Typography>
                <Box p={2}>
                    <div><div className={"field_key"}>Participant ID:</div> {props.ExperimentInformation.Participant_ID} </div>
                    <div><div className={"field_key"}>Local Experiment ID:</div> {props.ExperimentInformation.Submitter_ID}</div>
                </Box>
            </Grid>
        </Fragment>
    );
}

const GetBioBankInfo = (props) => {
    return (
        <Fragment>
            <Grid item lg={12}>
                <Typography variant={"h6"} > EGA BIOBANK INFORMATION </Typography>
                <Box p={2}>
                    <div><div className={"field_key"}>EGA ID:</div> { props.ExperimentInformation.EGA_ID ? props.ExperimentInformation.EGA_ID : "None" } </div>
                    <div><div className={"field_key"}>BioBank Sample ID: </div> { props.ExperimentInformation.Sample_ID ? props.ExperimentInformation.Sample_ID : "None" } </div>
                    <div><div className={"field_key"}>BioBank Name :</div>  { props.ExperimentInformation.BioBank ? props.ExperimentInformation.BioBank : "None" } </div>
                </Box>
            </Grid>
        </Fragment>
    );
}

const GetSequencingInfo = (props) => {
    return(
        <Fragment>
            <Grid item lg={12}>
                <Typography variant={"h6"} > SEQUENCING INFORMATION</Typography>
                <Box p={2}>
                    <div><div className={"field_key"}>Tissue:</div> {props.ExperimentInformation.tissue}</div>
                    <div>
                        <div className={"field_key"}>Library Strategy: </div> {props.ExperimentInformation.library_strategy}
                    </div>
                    <div>
                        <div className={"field_key"}>Kit: </div>{props.ExperimentInformation.kit}
                    </div>
                </Box>
            </Grid>
        </Fragment>
    );
}

const GetStatus = (props) => {
    return (
        <Fragment>
            <Grid item lg={12}>
                <Typography variant={"h6"} > STATUS</Typography>
            </Grid>
            <Grid item lg={12}>
                <Box p={2}>
                        { getJSXCircle(props.ExperimentInformation.in_platform) } In Platform
                </Box>
                </Grid>
                <Grid item lg={12}>
                    <Box p={2}>
                        { getJSXCircle(props.ExperimentInformation.processed) } Processed
                    </Box>
                </Grid>
    </Fragment>);
}


export {GetIdentifier, GetBioBankInfo, GetSequencingInfo, GetStatus}
